module.exports = __webpack_public_path__ + "media/images/BW-44b4dbac75fd35ec41fdfd7e2759ace8.png";